import { useState, useCallback, useMemo } from 'react';

interface Options {
  startFromPage?: number;
  itemsPerPage?: number;
}

const initOptions: Options = {
  startFromPage: 0,
  itemsPerPage: 1,
};

export const useNavigation = <T>(data: T[], options: Options = initOptions) => {
  const [currentPage, setCurrentPage] = useState(
    () => options.startFromPage || 0
  );

  const { itemsPerPage = 1 } = options;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const disableNextButton = currentPage === totalPages - 1;
  const disabledPrevButton = currentPage === 0;

  const showPrevPage = useCallback(() => {
    setCurrentPage(currentPage - 1);
  }, [currentPage]);

  const showNextPage = useCallback(() => {
    setCurrentPage(currentPage + 1);
  }, [currentPage]);

  const startIndex = currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const slicedData = useMemo(
    () => data.slice(startIndex, endIndex),
    [data, startIndex, endIndex]
  );

  return {
    data: slicedData,
    disableNextButton,
    disabledPrevButton,
    currentPage,
    showPrevPage,
    showNextPage,
    totalPages,
  };
};
